<app-carousel></app-carousel>
<body>
    <div class="container">
        <div class="row" style="padding-top:40px;">
            <div class="col-sm-12">
                <div >
                    <div id="Logo"></div>
                </div>
                <span class="headerText">About us</span>
                <div>
                    <p class="home-text" style="margin-top:10px;">
                    Plant Place is a Garden Store in the Philippines started in March 2019, We Offer different kinds of
                    Plants for Indoors and Outdoors which can use for your home, office and other events purposes.
                    <br><br>
                    We also matter our environment where we are living by encouraging everyone to be part of nature conservation
                    by simply starting a small garden at home or other simple acts. This will help our nature and also ourselves to sustain
                    our daily needs.
                    <br><br>
                    Also, reach us on our social media accounts to get updated to our available plants and home gardening 
                    sharing tips!
                </p>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top:20px;padding-bottom:40px;">
            <div class="col-sm-12">
                <span class="headerText">Our Location</span>
                <div>
                    <p class="home-text" style="margin-top:10px;">#4528 San Vicente Ferrer Street, Brgy 178 Camarin, North Caloocan</p>
                </div>
            </div>
        </div>
    </div>
</body>

